<template>
  <Dialog
    v-model="dialog"
    :title="$t('releaseNotes.csas.title')"
    :buttons="buttons"
    header-type="information"
  >
    <template #leftIcon>
      <v-img contain width="56" height="56" :src="$asset('img/icons/hospital.svg')" />
    </template>
    <template #text>
      <div class="mb-8 mb-md-6" v-html="$t(`releaseNotes.csas.perex`)"></div>
      <div class="grey-lighten-2 rounded-lg pa-4 text-left">
        <div
          v-for="(noteContent, index) in notesContent"
          :key="`release-notes-branded-info-list-item_${index}`"
          :class="{
            'mt-6': index > 0
          }"
        >
          <div class="d-flex justify-start align-center">
            <div>
              <v-img
                contain
                width="48"
                height="48"
                :src="$asset(`img/icons/${noteIcons[index]}.svg`)"
                class="mr-4"
              />
            </div>
            <div v-html="noteContent" />
          </div>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import releaseNotes from '@/mixins/releaseNotes';

export default {
  name: 'ReleaseNotesBrandedModal',
  mixins: [releaseNotes],
  computed: {
    notesContent() {
      return this.$t('releaseNotes.csas.content');
    },
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'releaseNotesCsas';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    buttons() {
      return [
        {
          events: {
            click: () => this.nextButtonAction()
          },
          text: this.$t('releaseNotes.csas.primaryButtonText')
        }
      ];
    },
    noteIcons() {
      return ['two-doctors', 'family', 'compass'];
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.gtmPush({ event: 'notification_show', 'notification.type': 'releaseCsas' });
        this.updateReleaseNotes();
      }
    }
  },
  mounted() {
    if (this.dialog) {
      this.updateReleaseNotes();
    }
  },
  methods: {
    nextButtonAction() {
      //notification.button must be same as button text
      this.gtmPush({
        event: 'notification_click',
        'notification.button': this.$t('releaseNotes.csas.primaryButtonText'),
        'notification.type': 'releaseCsas'
      });

      window.open('https://sites.google.com/ulekare.cz/ordinaceolbrachtova/dom%C5%AF', '_blank');
    }
  }
};
</script>
